
/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
// import 'react-dropzone-component/styles/filepicker.css'
import { useEffect, useState } from "react";
import HelpImage from "assets/images/HelpImage.png";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 PRO React TS components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Material Dashboard 2 PRO React TS examples components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
// import dataTableData from "layouts/applications/data-tables/data/dataTableData";
import { Autocomplete, Checkbox, FormControlLabel, FormGroup, Icon, IconButton, Popover, TextField, Typography } from "@mui/material";
import { CategoryDto, SubCategoryDto, subjects, Table } from "types";
import MDInput from "components/MDInput";
import { useAppContext } from "context/app-context";
import { getUUIDFromKey } from "utils/helpers";
import Alert from "components/Alert";
import { createSubCategory, deleteSubCategory, getMySubCategories, updateSubCategory } from "services/sub-category-services";
import { getMyCategoriesPerSubjectId } from "services/category-services";


interface CardType {
  PK: string
  title: string
  category: string
  subject: string
  grade: string
  isShared: boolean
}

function SubCategories(): JSX.Element {
  const [grades, setGrades] = useState([])
  const [pk, setPk] = useState<string>('')
  const [isShared, setIsShared] = useState(false)
  const [gradeValue, setGradeValue] = useState<string | null>(null);
  const [inputGradeValue, setGradeInputValue] = useState('');
  const [subjectValue, setSubjectValue] = useState<string | null>(null);
  const [inputSubjectValue, setSubjectInputValue] = useState('');
  const [categoryValue, setCategoryValue] = useState<CategoryDto | null>(null);
  const [inputCategoryValue, setCategoryInputValue] = useState('');
  const [data, setData] = useState({} as Table)
  const [card, setCard] = useState({} as CardType)
  const [dataTableData, setDataTableData] = useState<null | Table>(null)
  const [categories, setCategories] = useState<CategoryDto[]>([])
  const [subCategories, setSubCategories] = useState<SubCategoryDto[]>([])
  const [title, setTitle] = useState<string>('')
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
      setAnchorEl(event.currentTarget)
  }

  const handlePopoverClose = () => {
      setAnchorEl(null)
  }

  const popoverOpen = Boolean(anchorEl)

  useEffect(() => {

    if (subjectValue) {
      (async () => {
        setCategories(await getMyCategoriesPerSubjectId(subjectValue))
      })()
    }
  }, [subjectValue])

  useEffect(() => {
   (async () => {
     setSubCategories(await getMySubCategories())
    })()
  }, [])
  

  useEffect(() => {

      setDataTableData({
        columns: [
          { Header: "Redigér", accessor: "editLink", width: "10%" },
          { Header: "Slet", accessor: "removeLink", width: "10%" },
          { Header: "titel", accessor: "name", width: "50%" },
          { Header: "Kategori", accessor: "category", width: "10%" },
          { Header: "Klassetrin", accessor: "grade", width: "10%" },
          { Header: "Fag", accessor: "subject", width: "10%" },
        ], rows: subCategories || []
      })

  }, [subCategories])

  useEffect(() => {
    if (categoryValue && Object.keys(categoryValue).length){
      switch (categoryValue.grade) {
        case '0-10 kl.':
          setGrades(['0-10 kl.', '0-6 kl.', '4-10 kl.', 'indskoling', 'mellemtrin', 'udskoling', '0. klasse',
          '1. klasse', '2. klasse', '3. klasse', '4. klasse', '5. klasse', '6. klasse', '7. klasse', '8. klasse',
          '9. klasse', '10. klasse'])
          break
        case '0-6 kl.':
          setGrades(['0-6 kl.', 'indskoling', 'mellemtrin', '0. klasse', '1. klasse', '2. klasse', '3. klasse', '4. klasse', '5. klasse', '6. klasse'])
          break;
        case '4-10 kl.':
          setGrades(['4-10 kl.', 'mellemtrin', 'udskoling', '4. klasse', '5. klasse', '6. klasse', '7. klasse', '8. klasse', '9. klasse', '10. klasse'])
          break;
        case 'indskoling':
          setGrades(['indskoling','0. klasse', '1. klasse', '2. klasse', '3. klasse'])
          break;
        case 'mellemtrin':
          setGrades(['mellemtrin', '4. klasse', '5. klasse', '6. klasse'])
          break;
        case 'udskoling':
          setGrades(['udskoling', '7. klasse', '8. klasse', '9. klasse', '10. klasse'])
          break;

        default:
          setGrades([categoryValue.grade])
          break;
      }
    }
  }, [categoryValue])
  


  useEffect(() => {
    if (dataTableData) {
      setData({
        ...dataTableData, rows: dataTableData.rows.map((dt) => {
          return {
            ...dt, category: dt.category.name, subject: dt.category.subject, grade: dt.grade,
            editLink: (
              <IconButton onClick={() => {
                setCard({ ...dt, title: dt.name, PK: dt.PK, subject: dt.category.subject, grade: dt.grade || dt.category.grade, category: dt.category.name, isShared: dt.isShared as boolean })
              }}><Icon fontSize="small">edit</Icon></IconButton>
            ),
            removeLink: (
              <IconButton onClick={async () => {
                warningWithConfirmAndCancelMessage(dt.PK, dt.category.category, dt.countQuizzes, dt.countCardCollections)
              }}><Icon fontSize="small">delete</Icon></IconButton>
            )
          }
        }
        )
      })
    }
  }, [dataTableData])


  useEffect(() => {
    if (Object.keys(card).length) {
      setPk(card.PK)
      const subcategory = subCategories.find(sub => sub.PK === card.PK) 
      //@ts-ignore
      setCategoryValue({ //@ts-ignore
        PK: subcategory.category.category, grade: subcategory.category.grade, name: subcategory.category.name, subject: subcategory.category.subject
      })
      setGradeValue(card.grade)
      setSubjectValue(card.subject)
      setTitle(card.title)
      setIsShared(card.isShared)
    }
  }, [card])


  const { user, handleMessage } = useAppContext()

  const handleCreateSubCategory = async () => {
    try {
      const category = categoryValue.PK
      const PK = await createSubCategory(getUUIDFromKey(category), {
        name: title, color: 'transparent', isShared, fromAdmin: user.role === 'ADMIN', grade: gradeValue
      })
      setDataTableData({
        ...dataTableData, rows:  [...dataTableData.rows, { PK: `SUBCATEGORY#${PK}`, name: title, grade: gradeValue, color: 'transparent', isShared, fromAdmin: user.role === 'ADMIN', category: { name: categoryValue.name, subject: subjectValue, grade: gradeValue, category: category } }]
      })
      handleMessage('Du har oprettet en underkategori', 'success')
    } catch (error) {
      //@ts-ignore
      handleMessage(error?.response?.data?.message || error?.message, 'error')
    }
  }

  const handleUpdateSubCategory = async () => {
    try {
      const category = getUUIDFromKey(categoryValue.PK)

      const updatedCategory = await updateSubCategory(category, getUUIDFromKey(pk), {
        name: title, color: 'transparent', isShared, fromAdmin: user.role === 'ADMIN', grade: gradeValue
      })

      dataTableData.rows.splice(dataTableData.rows.findIndex((dt: any) => dt.PK === pk), 1, 
      { ...updatedCategory, 
        category: {
          category: categoryValue.PK,
          name: categoryValue.name,
          subject: subjectValue,
          grade: gradeValue } })
      setDataTableData({
        ...dataTableData, rows: [...dataTableData.rows]
      })
      setTitle('')
      setPk('')
      setGradeValue('')
      setSubjectValue('')
      setCategoryValue({} as CategoryDto)
      handleMessage(`Du har opdateret underkategorien ${title}`, 'success')
    } catch (error) {
      //@ts-ignore
      handleMessage(error?.response?.data?.message || error?.message, 'error')
    }
  }

  const handleDeleteSubCategory = async (subCategoryId: string, categoryId: string) => {
    try {
      await deleteSubCategory(getUUIDFromKey(categoryId), getUUIDFromKey(subCategoryId))
      setDataTableData({
        ...dataTableData, rows: dataTableData.rows.filter(dt => dt.PK !== subCategoryId)
      })
      success()
    } catch (error) {
      //@ts-ignore
      handleMessage(error?.response?.data?.message || error?.message, 'error')
    }

  }
  const [alert, setAlert] = useState(null)

  const hideAlert = () => {
    setAlert(null);
  };
  const success = (type = 'archive') => {
    setAlert(
      //@ts-ignore
      <Alert
        success
        style={{
          display: 'block',
          marginTop: '-100px',
        }}
        title='Slettet!'
        confirmBtnText='Okay'
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnBsStyle='success'
        btnSize=''
      > Din kategori blev slettet...</Alert>
    );
  };
  const cancel = () => {
    setAlert(
      <Alert
        danger
        style={{
          display: 'block',
          marginTop: '-100px',
        }}
        title='Aflyst'
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnText='Okay'
        confirmBtnBsStyle='success'
        btnSize=''
      ></Alert>
    );
  };
  const warningWithConfirmAndCancelMessage = (id: string, categoryId: string, countQuizzes: number, countCardCollections: number) => {
    setAlert(
      //@ts-ignore
      <Alert
        warning
        style={{
          display: 'block',
          marginTop: '-100px',
        }}
        title='Er du sikker?'
        onConfirm={async () => {
          await handleDeleteSubCategory(id, categoryId);
        }}
        onCancel={() => cancel()}
        confirmBtnBsStyle='success'
        cancelBtnBsStyle='danger'
        confirmBtnText='Ja, slet!'
        cancelBtnText='Annullér'
        showCancel
        btnSize=''
      >
        {countQuizzes ?
          `Advarsel- denne quizkategori har ${countQuizzes} spørgsmål tilknyttet! Er du sikker på at du vil slette denne quizkategori?` : 'Er du sikker på at du vil slette denne quizkategori?'}
        
        {countQuizzes ? (<>
        <br/>
        <br/>
        <p>OBS: hvis du sletter denne quiz-kategori, så sletter du også quiz-kategorien på alle kort hvor den er brugt</p>
        </>
        ) : null}
      </Alert>
    );
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={6} mb={3}>
        <Grid spacing={3} justifyContent="center">
          {alert}
          <Grid item xs={12} lg={8}>
            <Card>
              <MDBox p={3} lineHeight={1} display='flex' alignItems='center' gap={1}>
                <MDTypography variant="h5" fontWeight="medium">
                  Mine Quiz-kategorier
                </MDTypography>
                <Typography
                  aria-owns={popoverOpen ? 'mouse-over-popover' : undefined}
                  aria-haspopup="true"
                  onMouseEnter={handlePopoverOpen}
                  onMouseLeave={handlePopoverClose}
                  style={{
                    lineHeight: '1rem',
                    cursor: 'pointer',
                  }}>
                  <Icon>help</Icon>
                </Typography>
                <Popover
                  id="mouse-over-popover"
                  style={{ pointerEvents: 'none' }}
                  PaperProps={{sx: { backgroundColor: '#fff'}}}
                  disableAutoFocus
                  disableEnforceFocus
                  open={popoverOpen}
                  anchorEl={anchorEl}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                  }}
                  onClose={handlePopoverClose}>
                    <img src={HelpImage} width={380} alt="quizCategory" />
                  {/* <Typography style={{ paddingLeft: 10, paddingRight: 10 }}>
                    <p>Quizkategorierne er dem der vælges og vises på kortene.</p>
                  </Typography> */}
                </Popover>
              </MDBox>
              <Grid container>
                <Grid style={{ overflowX: 'auto' }} item sm={12} lg={8} >
                  {Object.keys(data).length ? <DataTable table={data} canSearch /> : null}
                </Grid>
                <Grid item sm={12} lg={4} >
                  <MDBox
                    justifyContent='space-between'
                    alignItems='center'
                    display='flex'
                    flexDirection='column'>
                    <MDBox mt={1} px={2} width={"100%"}>
                      <MDBox mt={1} px={2} max-width={500}>
                        <Card>
                          <MDBox mt={1} mx={1}>
                            <Autocomplete
                              noOptionsText="Ingen muligheder endnu"
                              value={subjectValue}
                              onChange={(event: any, newValue: string | null) => {
                                setSubjectValue(newValue);
                              }}
                              inputValue={inputSubjectValue}
                              onInputChange={(event, newInputValue) => {
                                if (newInputValue === '') {
                                  setCategories([])
                                  setCategoryValue({} as CategoryDto)
                                }
                                setSubjectInputValue(newInputValue);
                              }}
                              id="controllable-states-grades"
                              options={subjects}
                              renderInput={(params) => <TextField {...params} label="Fag/emner" />}
                            />
                          </MDBox>
                          <MDBox mt={1} mx={1}>
                            <Autocomplete
                              noOptionsText="Ingen muligheder endnu"
                              value={categoryValue}
                              // @ts-ignore
                              onChange={(event: any, newValue: CategoryDto | null) => {
                                setCategoryValue(newValue);
                              }}
                              getOptionLabel={(option) => (option as CategoryDto).name || ''}

                              inputValue={inputCategoryValue}
                              onInputChange={(event, newInputValue) => {
                                setCategoryInputValue(newInputValue);
                              }}
                              id="controllable-states-grades"
                              options={categories}
                              renderInput={(params) => <TextField {...params} label="Kategori" />}
                            />
                          </MDBox>
                          <MDBox mt={1} mx={1}>
                            <Autocomplete
                              noOptionsText="Ingen muligheder endnu"
                              value={gradeValue}
                              onChange={(event: any, newValue: string | null) => {
                                setGradeValue(newValue);
                              }}
                              inputValue={inputGradeValue}
                              onInputChange={(event, newInputValue) => {
                                setGradeInputValue(newInputValue);
                              }}
                              id="controllable-states-grades"
                              options={grades}
                              renderInput={(params) => <TextField {...params} label="Klassetrin" />}
                            />
                          </MDBox>
                          <MDBox mt={1} mx={1}>
                            <MDInput
                              fullWidth
                              label="Navn på Quizkategori"
                              value={title}
                              onChange={(e: any) => setTitle(e.target.value)}
                            />
                          </MDBox>
                          <MDBox mt={1} mx={1}>
                            <FormGroup>
                              <FormControlLabel control={
                                <Checkbox checked={isShared} onChange={(event: React.ChangeEvent<HTMLInputElement>) => setIsShared(event.target.checked)}
                                />
                              } label="del med andre" />
                            </FormGroup>
                          </MDBox>
                          <MDBox p={3} px={10} mx='auto'>
                            {!!pk ?
                              <MDButton onClick={handleUpdateSubCategory} color='info'>Gem dine rettelser</MDButton> : <MDButton onClick={handleCreateSubCategory} color='info'>Opret quiz-kategori</MDButton>}
                          </MDBox>
                        </Card>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </Grid>
              </Grid>
            </Card>
          </Grid>
        </Grid>
      </MDBox >
    </DashboardLayout >
  );
}

export default SubCategories;
